// Auth actions
export const SET_LOGIN_AUTH = 'SET_LOGIN_AUTH';
export const SET_LOGOUT_AUTH = 'SET_LOGOUT_AUTH';
export const INITIALIZE_APP = 'INITIALIZE_APP';
export const INITIALIZE_USER_APP_DATA = 'INITIALIZE_USER_APP_DATA';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_USER_PERMISSIONS = 'UPDATE_USER_PERMISSIONS';
export const USER_GROUPS = 'USER_GROUPS';

export const REFRESH_INVENTORY = 'REFRESH_INVENTORY';
export const SELECT_INVENTORY_ITEM = 'SELECT_INVENTORY_ITEM';
export const SEARCH_INVENTORY_ITEM = 'SEARCH_INVENTORY_ITEM';
export const SHOW_MESSAGE_ALERT = 'SHOW_MESSAGE_ALERT';

export const ORDER_HISTORY_SEARCH_FILTER = 'ORDER_HISTORY_SEARCH_FILTER';
export const ORDER_HISTORY_DATE_FILTER = 'ORDER_HISTORY_DATE_FILTER';

export const SET_CLINICS = 'SET_CLINICS';
export const SET_SELECTED_CLINIC = 'SET_SELECTED_CLINIC';
export const USER_TYPE = 'USER_TYPE';
export const GROUP_ID = 'GROUP_ID';
export const DEFAULT_CLINIC_ID = 'DEFAULT_CLINIC_ID';
export const DELETE_CLINIC_ID = 'DELETE_CLINIC_ID';
export const CLINIC_DETAILS = 'CLINIC_DETAILS';
export const EDIT_CLINIC_ID = 'EDIT_CLINIC_ID';
export const DELETE_GROUP_STATUS = 'DELETE_GROUP_STATUS';
export const SET_CLINIC_NOTIFICATION_BATCHES =
  'SET_CLINIC_NOTIFICATION_BATCHES';

export enum FILTERS {
  RESET_TO_INITIAL_STATE = 'RESET_TO_INITIAL_STATE',
  EXPIRING_VACCINE_FROM_DATE = 'EXPIRING_VACCINE_FROM_DATE',
  EXPIRING_VACCINE_TO_DATE = 'EXPIRING_VACCINE_TO_DATE',
  EXPIRED_VACCINE_DATE = 'EXPIRED_VACCINE_DATE',
  VACCINE_PROGRAM_ID = 'VACCINE_PROGRAM_ID',
  EXPIRED_VACCINE_PROGRAM_ID = 'EXPIRED_VACCINE_PROGRAM_ID',
  EXPIRING_VACCINE_PROGRAM_ID = 'EXPIRING_VACCINE_PROGRAM_ID',
  RETURN_VACCINES_DETAILS = 'RETURN_VACCINES_DETAILS',
  EXPIRED_VACCINE_ID = 'EXPIRED_VACCINE_ID',
  RETURN_EXPIRING_VACCINES_DETAILS = 'RETURN_EXPIRING_VACCINES_DETAILS',
  EXPIRING_VACCINE_ID = 'EXPIRING_VACCINE_ID'
}

export const PAYMENT_METHOD_ID = 'PAYMENT_METHOD_ID';
export const PATIENT_PAYMENT_DETAILS_ID = 'PATIENT_PAYMENT_DETAILS_ID';
export const PATIENT_PAYMENT_TOKEN = 'PATIENT_PAYMENT_TOKEN';
export const SCHEDULE_SEND_DATE = 'SCHEDULE_SEND_DATE';
export const GUARANTOR_CARD_PAYMENT = 'GUARANTOR_CARD_PAYMENT';
export const GUARANTOR_PAY_AMOUNT = 'GUARANTOR_PAY_AMOUNT';
export const GUARANTOR_PAY_CASH_AMOUNT = 'GUARANTOR_PAY_CASH_AMOUNT';
export const PATIENTS_SHARED = 'PATIENTS_SHARED';
export const GUARANTOR_LOGIN = 'GUARANTOR_LOGIN';
export const PAYMENT_CLINIC_DETAILS = 'PAYMENT_CLINIC_DETAILS';
export const PAYMENT_SHOW_DUE_NOTICE = 'PAYMENT_SHOW_DUE_NOTICE';
export const STATEMENT_SELECTED_CLINIC = 'STATEMENTS_SELECTED_CLINIC';
export const BASE_DETAILS = 'BASE_DETAILS';
export const PAYMENT_TYPE = 'PAYMENT_TYPE';
export const ADHOC_PAYMENT_DATA = 'ADHOC_PAYMENT_DATA';
export const PAYMENT_AMOUNTS_DATA = 'PAYMENT_AMOUNTS_DATA';
export const BALANCE_FORWARD_DATA = 'BALANCE_FORWARD_DATA';
export const CARD_MACHINE_PAYMENT_REFERENCE_ID =
  'CARD_MACHINE_PAYMENT_REFERENCE_ID';
export const CARD_MACHINE_DETAILS_OBJECT = 'CARD_MACHINE_DETAILS_OBJECT';
export const PATIENT_RECALL_SELECTED_CATEGORY =
  'PATIENT_RECALL_SELECTED_CATEGORY';

// New messages Action
export const MESSAGE_COUNT = 'MESSAGE_COUNT';

// Logout Action
export const GUARANTOR_LOGOUT = 'GUARANTOR_LOGOUT';

export const SWITCH_TABS = 'SWITCH_TABS';
export const SET_DEFAULT_CLINIC_GROUP_AFTER_AUTH =
  'SET_DEFAULT_CLINIC_GROUP_AFTER_AUTH';
export const SET_DEFAULT_TAB_AFTER_AUTH = 'SET_DEFAULT_TAB_AFTER_AUTH';
export const SET_VERIFY_OTP_USER_DETAILS = 'SET_VERIFY_OTP_USER_DETAILS';

export const LOCATIONS = 'LOCATIONS';

export const BILLING_CLINIC_ID = 'BILLING_CLINIC_ID';

export const INSTALLMENT_DETAILS = 'INSTALLMENT_DETAILS';

export const GROUP_TYPE = 'GROUP_TYPE';

// Patient Drawer Action
export const PATIENT_DRAWER_DETAILS = 'PATIENT_DRAWER_DETAILS';

//Close Patient Drawer Action
export const CLOSE_SHOW_PATIENT_DRAWER = 'CLOSE_SHOW_PATIENT_DRAWER';

export const SET_LOADING_PATIENT_DRAWER_DATA =
  'SET_LOADING_PATIENT_DRAWER_DATA';
export const SET_ERROR_PATIENT_DRAWER_DATA = 'SET_ERROR_PATIENT_DRAWER_DATA';
export const SET_PATIENT_DRAWER_PATIENT_DETAILS =
  'SET_PATIENT_DRAWER_PATIENT_DETAILS';
export const SET_ELIGIBILITY_VERIFICATION_APPOINTMENT_PATIENT_DRAWER =
  'SET_ELIGIBILITY_VERIFICATION_APPOINTMENT_PATIENT_DRAWER';
export const SET_ELIGIBILITY_NETWORK_APPOINTMENT_DRAWER =
  'SET_ELIGIBILITY_NETWORK_APPOINTMENT_DRAWER';
export const SET_ALL_WORKFLOWS_PATIENTS_DRAWER =
  'SET_ALL_WORKFLOWS_PATIENTS_DRAWER';

// SET ACTIVE TAB

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
// Group Actions
export const SET_ALL_GROUPS = 'SET_ALL_GROUPS';
export const SET_SELECTED_GROUP = 'SET_SELECTED_GROUP';
export const SET_SELECTED_GROUP_ID = 'SET_SELECTED_GROUP_ID';
export const SET_SELECTED_GROUP_USERS = 'SET_SELECTED_GROUP_USERS';
export const SET_SELECTED_GROUP_CLINICS = 'SET_SELECTED_GROUP_CLINICS';
export const SET_GROUP_USERS = 'SET_GROUP_USERS';
export const SET_GROUP_CLINICS = 'SET_GROUP_CLINICS';
export const SET_SELECTED_GROUP_CARD_MACHINES =
  'SET_SELECTED_GROUP_CARD_MACHINES';
export const SET_SELECTED_GROUP_HEALTHCARE_PROVIDERS =
  'SET_SELECTED_GROUP_HEALTHCARE_PROVIDERS';
export const SET_ACCESS_OF_CLINICS = 'SET_ACCESS_OF_CLINICS';
export const RESET_GROUP_STATE = 'RESET_GROUP_STATE';
export const MESSAGE_TAB_OPTIONS = 'MESSAGE_TAP_OPTIONS';
export const MESSAGE_TAB_FILTERS = 'MESSAGE_TAP_FILTERS';

export const RESET_PAYMENTS_REDUCER = 'RESET_PAYMENTS_REDUCER';
export const SET_APPOINTMENT_PORTAL_PATIENT_ID =
  'SET_APPOINTMENT_PORTAL_PATIENT_ID';
export const SET_PATIENT_APPT_AND_TICKET_SUMMARY =
  'SET_PATIENT_APPT_AND_TICKET_SUMMARY';
export const SET_SELECTED_GROUP_ENABLED_MODULES =
  'SET_SELECTED_GROUP_ENABLED_MODULES';
export const UPDATE_SCHEDULED_APPOINTMENT = 'UPDATE_SCHEDULED_APPOINTMENT';
export const GET_APPOINTMENT_SLOT = 'GET_APPOINTMENT_SLOT';

//CCM timers
export const CCM_START_TIMER = 'CCM_START_TIMER';
export const CCM_STOP_TIMER = 'CCM_STOP_TIMER';
export const CCM_RESET_TIMER = 'CCM_RESET_TIMER';
export const SINGLE_CCM_PATIENT_DETAILS = 'SINGLE_CCM_PATIENT_DETAILS';
export const START_TIMER_FROM_PATIENT_DRAWER =
  'START_TIMER_FROM_PATIENT_DRAWER';
export const UPDATE_STOP_TIMER_NOTES = 'UPDATE_STOP_TIMER_NOTES';
export const UPDATE_FOLLOW_UP_NOTES = 'UPDATE_FOLLOW_UP_NOTES';
export const USER_HAS_ADMIN_ROLE_AND_REPORTS_ENABLE =
  'USER_HAS_ADMIN_ROLE_AND_REPORTS_ENABLE';
export const SET_UPCOMING_APPOINTMENT_DATA = 'SET_UPCOMING_APPOINTMENT_DATA';
export const UPDATE_CCM_PATIENT_DEFAULT_STATE =
  'UPDATE_CCM_PATIENT_DEFAULT_STATE';

// Appointment portal
export const APPOINTMENT_LOGIN = 'APPOINTMENT_LOGIN';
export const PATIENT_APPOINTMENT_TOKEN = 'PATIENT_APPOINTMENT_TOKEN';
export const APPOINTMENT_LOGOUT = 'APPOINTMENT_LOGOUT';
export const SET_APPOINTMENT_PORTAL_SELECTED_VACCINE =
  'SET_APPOINTMENT_PORTAL_SELECTED_VACCINE';
export const SET_APPOINTMENT_PORTAL_SELECTED_SLOTS =
  'SET_APPOINTMENT_PORTAL_SELECTED_SLOTS';
export const SET_APPOINTMENT_PORTAL_INSURANCE_DETAILS =
  'SET_APPOINTMENT_PORTAL_INSURANCE_DETAILS';
export const SET_APPOINTMENT_PORTAL_COMMON = 'SET_APPOINTMENT_PORTAL_COMMON';
export const SET_AVAILABLE_VACCINE_LIST = 'SET_AVAILABLE_VACCINE_LIST';

export const UPDATE_FOLLOW_UP_DUE_DATE_AND_ASSIGNEE =
  'UPDATE_FOLLOW_UP_DUE_DATE_AND_ASSIGNEE';

// Subscription Charges
export const SET_SUBSCRIPTION_CHARGES_CARD_AND_CONFIG_DETAILS =
  'SET_SUBSCRIPTION_CHARGES_CARD_AND_CONFIG_DETAILS';
export const SET_SUBSCRIPTION_CHARGES_INVOICES =
  'SET_SUBSCRIPTION_CHARGES_INVOICES';
export const SET_SUBSCRIPTION_CHARGES_PAYMENT_HISTORY =
  'SET_SUBSCRIPTION_CHARGES_PAYMENT_HISTORY';

// PRIOR AUTH TIMER TYPE
export const START_TICKET_TIMER = 'START_TICKET_TIMER';
export const STOP_TICKET_TIMER = 'STOP_TICKET_TIMER';
export const RESET_TICKET_TIMER = 'RESET_TICEKT_TIMER';

// PRIOR AUTH TYPE
export const PRIOR_AUTH_DEFAULT_CLINIC_ID = 'PRIOR_AUTH_DEFAULT_CLINIC_ID';
export const PRIOR_AUTH_DEFAULT_FILTERS = 'PRIOR_AUTH_DEFAULT_FILTERS';
export const RESET_UNATTENDED_PRIOR_AUTH = 'RESET_UNATTENDED_PRIOR_AUTH';

// CLAIMS MODULE TYPE
export const CLAIMS_DEFAULT_CLINIC_ID = 'CLAIMS_DEFAULT_CLINIC_ID';
export const CLAIMS_DEFAULT_FILTERS = 'CLAIMS_DEFAULT_FILTERS';
export const RESET_UNATTENDED_CLAIMS = 'RESET_UNATTENDED_CLAIMS';

// REFERRALS MODULE TYPE
export const REFERRALS_DEFAULT_CLINIC_ID = 'REFERRALS_DEFAULT_CLINIC_ID';
export const REFERRALS_DEFAULT_FILTERS = 'REFERRALS_DEFAULT_FILTERS';
export const RESET_UNATTENDED_REFERRALS = 'RESET_UNATTENDED_REFERRALS';

export const GENERATE_DOB_FOR_CCM_USER_ROLE = 'GENERATE_DOB_FOR_CCM_USER_ROLE';
